import React from "react"
import { Collapse, Row } from "reactstrap"
import classnames from "classnames"
import MobileTableBody from "./MobileTableBody"

const MobileView = ({ sethandleAccordion, handleAccordion, keyId, data }) => {
  const handleOnclickAccordion = value => {
    if (handleAccordion === value) {
      sethandleAccordion(null)
    } else {
      sethandleAccordion(value)
    }
  }
  
  return (
    <React.Fragment>
      <Row>
        <div className="accordion" id="accordion" key={keyId}>
          <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingOne">
              <button
                className={classnames(
                  "accordion-button zIndexes zIndexesNo",
                  "fw-medium",
                  {
                    collapsed: handleAccordion !== keyId,
                  }
                )}
                type="button"
                onClick={() => handleOnclickAccordion(keyId)}
                style={{ cursor: "pointer" }}
              >
                {data?.employeeName}
              </button>
            </h2>
            <Collapse
              isOpen={handleAccordion === keyId}
              className="accordion-collapse"
            >
              <div className="accordion-body">
                <div className="text-muted">
                  <>
                    <table className="table table-striped">
                      <div className="text-end d-block mb-2 text-uppercase font-weight-bold"></div>
                      <tbody>
                        <MobileTableBody item={data} hidecolumn={true} />
                      </tbody>
                    </table>
                  </>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </Row>
    </React.Fragment>
  )
}
export default MobileView
